import { render, staticRenderFns } from "./AgentFloatingIcon.vue?vue&type=template&id=3354e906&scoped=true"
import script from "./AgentFloatingIcon.vue?vue&type=script&lang=js"
export * from "./AgentFloatingIcon.vue?vue&type=script&lang=js"
import style0 from "./AgentFloatingIcon.vue?vue&type=style&index=0&id=3354e906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3354e906",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
